import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { select } from '@ngrx/store';

import { SessionService } from '../../store/services/session.service';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const roles = route.data.roles as Array<string>;

    if (!roles.length) {
      return of(true);
    }
    return this.sessionService.onReady()
      .pipe(
        filter(session => !!session),
        select(sess => sess.user_type),
        map(userType => {
          return roles.indexOf(userType) !== -1 ? true : this.router.createUrlTree(['/']);
        }),
      );
  }
}
